/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import useUserInfo from './components/Authenticate/useUserInfo'; // Adjust the import path as necessary
import { Loader } from 'lucide-react';

interface AuthGuardProps {
  children: (props: {
    userInfo: any;
    userPermissions: any;
  }) => ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { userInfo, userPermissions, loading, error } = useUserInfo();

  if (loading) return <Loader className="animate-spin h-10 w-10 text-black" />
  if (error) return <div>Error loading user data: {error}</div>;

  return <>{children({ userInfo, userPermissions })}</>;
};

export default AuthGuard;
